function hideMenuByHeight(item, index){
  var ctaElementHeight = document.getElementsByClassName('cta-header-links')[0];
  var navHeaderElementHeight = document.getElementsByClassName('navbar__menu-header')[0];
}

export function navMobileExtra() {

  document.querySelectorAll('.special-mega-mobile').forEach(hideMenuByHeight);

}
